'use client';

import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import MagnifierIcon from '../atoms/icons/magnifier';
import Slider from '../content/slider/slider';
import UtilityButton from '../buttons/utilityButton';
import PersonIcon from '../atoms/icons/person';
import PlusIcon from '../atoms/icons/plus';
import { useBookingContext } from '../../contexts/bookingContext';
import HotelRequest from '../destination/hotelRequest';
import { getResponsiveImageUrl } from '../../utils/imageUrls';

const HotelRoomCategory = ({ category, index, hotel, season }) => {
  const { t } = useTranslation(['booking']);

  const { setVisible, setSeason, setHotel, setIsFullscreenModal } =
    useBookingContext();

  const showBookingModal = () => {
    setSeason(season?.toLowerCase());
    setHotel({ id: hotel.id, name: hotel.name });
    setVisible(true);
    setIsFullscreenModal(true);
  };

  const [showImages, setshowImages] = useState(false);

  const [showRequestForm, setShowRequestForm] = useState(false);

  const hasImage =
    category.rooms &&
    category.rooms.length > 0 &&
    category.rooms[0].images.length > 0;

  const imageUrls = hasImage
    ? category.rooms[0].images
    : [
        {
          id: 'image_placeholder',
          url: 'https://a.storyblok.com/f/260037/1186x791/b132f5a5d4/room_placeholder.jpg/m/768x576',
        },
      ];

  const imageUrlParams = {
    imageId: category.rooms[0]?.images[0]?.id,
    parentWidth: 'w-1/3',
    inSlider: true,
    forceAspect: 'aspect-4/3',
    filename:
      'https://a.storyblok.com/f/260037/1186x791/b132f5a5d4/room_placeholder.jpg',
  };

  const imageBloks = imageUrls.map((img, i) => {
    const blokImage = {
      component: 'hotel_image',
      _uid: `imageBlokUids${i}`,
      forceAspect: 'aspect-4/3',
      image: {
        id: img.id,
        alt: hotel.name,
      },
      width: '100%',
    };

    return blokImage;
  });

  const sliderUUid = `slider_${index}`;
  const fakeSlider = {
    component: 'slider',
    _uid: sliderUUid,
    blocks: imageBloks,
    width: '100%',
    automaticSlide: false,
    className: 'max-h-[80vh]',
  };

  return (
    <>
      <section
        key={index}
        className="flex flex-col justify-between col-span-12 md:col-span-6 lg:col-span-4 mt-4 bg-yellow-15"
      >
        <div className="mb-4">
          <div
            className="relative bg-black-12.5 rounded aspect-4/3 overflow-hidden"
            role={
              imageUrls[0].id !== 'image_placeholder' ? 'button' : undefined
            }
            onClick={
              imageUrls[0].id !== 'image_placeholder' && imageUrls.length > 0
                ? (e) => setshowImages(true)
                : null
            }
            onKeyUp={
              imageUrls[0].id !== 'image_placeholder' && imageUrls.length > 0
                ? (e) => setshowImages(true)
                : null
            }
            // tabIndex={imageUrls[0].id !== 'image_placeholder' ? 0 : undefined} TODO: Fix this/ check if it is needed
          >
            <picture>
              <source
                media="(max-width: 640px)"
                srcSet={getResponsiveImageUrl({
                  screenWidth: '640px',
                  ...imageUrlParams,
                })}
              />
              <source
                media="(max-width: 768px)"
                srcSet={getResponsiveImageUrl({
                  screenWidth: '768px',
                  ...imageUrlParams,
                })}
              />
              <source
                media="(max-width: 1024px)"
                srcSet={getResponsiveImageUrl({
                  screenWidth: '1024px',
                  ...imageUrlParams,
                })}
              />
              <source
                media="(min-width: 1024px)"
                srcSet={getResponsiveImageUrl({
                  screenWidth: '1440px',
                  ...imageUrlParams,
                })}
              />
              <img
                loading="lazy"
                src={getResponsiveImageUrl({
                  screenWidth: '640px',
                  ...imageUrlParams,
                })}
                alt={category.hotelDescription}
                className={`aspect-4/3 ${!hasImage ? 'opacity-60' : ''}`}
                /*         className={`object-cover w-full h-full rounded`} */
              />
            </picture>
            {/*             <img
              src={
                imageUrls[0].id === 'image_placeholder'
                  ? imageUrls[0].url
                  : getResponsiveImageUrl({
                      screenWidth: '1024px',
                      ...imageUrlParams,
                    })
              }
            />
 */}
            <div className="absolute bottom-0 px-2 py-2">
              <div
                className={`flex items-center flex-nowrap bg-white rounded pl-2`}
              >
                {Array(category.numberOfOrdinaryBeds)
                  .fill(0)
                  .map((_, i) => {
                    return (
                      <div
                        className={`flex text-xs rounded flex-nowrap items-center w-max py-2 pr-2`}
                        key={`ordinaryBedKeys_${i}`}
                      >
                        <PersonIcon />
                      </div>
                    );
                  })}
                {category.numberOfExtrabeds > 0 && (
                  <div
                    className={`flex text-xs rounded flex-nowrap items-center w-max pr-1`}
                  >
                    <PlusIcon />
                  </div>
                )}
                {category.numberOfExtrabeds > 0 &&
                  Array(category.numberOfExtrabeds)
                    .fill(0)
                    .map((_, index) => {
                      return (
                        <div
                          className={`flex text-xs rounded flex-nowrap items-center w-max py-2 pr-2`}
                          key={`extraBedKeys${index}`}
                        >
                          <PersonIcon />
                        </div>
                      );
                    })}
              </div>
            </div>
            {imageUrls.length > 0 &&
              imageUrls[0].id !== 'image_placeholder' && (
                <div className="absolute bottom-0 right-0 px-2 bg-white rounded m-2 p-2">
                  <MagnifierIcon className="mt-[0.25rem]" fill="#000000" />
                </div>
              )}
          </div>

          <div className="px-4 md:px-8">
            <h3 className="mt-4">
              {category.description}
              {category.squareMeter && (
                <span>
                  {' '}
                  - {category.squareMeter} m<sup>2</sup>
                </span>
              )}
            </h3>

            <p>{category.information}</p>
          </div>
        </div>
        <div className="px-2 md:px-3 -mt-3 pb-3">
          <UtilityButton
            label={t('Find price and book')}
            onClick={() => showBookingModal()}
            width="w-full"
          />
        </div>
      </section>
      <div
        className={` fixed left-0 top-0 z-60 ${
          !showImages ? 'hidden' : ''
        } inset-0 bg-black/80 overflow-y-none h-full w-full flex content-center align-center`}
        onClick={(e) => setshowImages(false)}
        role="button"
        onKeyUp={(e) => setshowImages(true)}
        tabIndex={0}
      >
        <div
          className="w-full md:max-w-screen-lg max-h-[100vh] p-8 m-auto z-40 relative"
          onClick={(e) => e.stopPropagation()}
          role="button"
          onKeyUp={(e) => e.stopPropagation()}
          tabIndex={0}
        >
          <div className="flex absolute right-4 -top-4 z-10 px-8 drop-shadow">
            <button
              onClick={() => {
                setshowImages(false);
              }}
              className="bg-yellow-60 rounded-full px-2 py-2 rotate-45"
            >
              <PlusIcon />
            </button>
          </div>

          <Slider blok={fakeSlider} />
        </div>
      </div>
      <HotelRequest
        showRequestModal={showRequestForm}
        setShowRequestModal={setShowRequestForm}
        hotel={hotel}
      />
    </>
  );
};

export default HotelRoomCategory;
